import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api, buildQuery } from "../../lib/api";
import type { ProductDetail, ProductPage } from "../../lib/types";

export interface ProductQuery {
	search: string;
	status: string;
	limit: number;
	offset: number;
	/** Restrict to products sold on a selling plan. */
	subscribable?: boolean;
}

export const useProducts = (query: ProductQuery) =>
	useQuery({
		queryKey: ["products", query],
		queryFn: () =>
			api.get<ProductPage>(
				`/api/products${buildQuery({
					q: query.search || undefined,
					status: query.status || undefined,
					limit: query.limit,
					offset: query.offset,
					subscribable: query.subscribable ? "1" : undefined,
				})}`,
			),
		placeholderData: keepPreviousData,
	});

export const useProduct = (productId: string | undefined) =>
	useQuery({
		queryKey: ["product", productId],
		queryFn: () => api.get<ProductDetail>(`/api/products/${productId}`),
		enabled: Boolean(productId),
	});
